module.exports = "/_next/static/images/img__empty-search-e808dd093220526e0464b721b725c276.png";